import { MAX_COUNTER, SYNC_KEYS, parseHlc } from "@beresta/core";
export class SqlSyncState {
    db;
    constructor(db) {
        this.db = db;
    }
    async get(key) {
        const rows = await this.db.query("SELECT value FROM sync_state WHERE key = ?", [key]);
        return rows[0]?.value ?? null;
    }
    async set(key, value) {
        await this.db.exec("INSERT INTO sync_state (key, value) VALUES (?, ?) ON CONFLICT(key) DO UPDATE SET value = excluded.value", [key, value]);
    }
    async remove(key) {
        await this.db.exec("DELETE FROM sync_state WHERE key = ?", [key]);
    }
}
/**
 * Водяний знак годинника в рядок і назад.
 *
 * Формат навмисно простий і не той, що в самої мітки: тут немає
 * ідентифікатора пристрою, бо це наш власний стан, а не подія.
 */
export function formatWatermark(state) {
    return `${state.millis}.${state.counter}`;
}
/**
 * Розбирає водяний знак. Сміття дає `null`, а не виняток: зіпсований
 * рядок у службовій таблиці не привід не піднятися — годинник просто
 * почне з настінного часу, як робив досі.
 */
export function parseWatermark(value) {
    if (!value)
        return null;
    const m = /^(\d+)\.(\d+)$/.exec(value);
    if (!m)
        return null;
    const millis = Number(m[1]);
    const counter = Number(m[2]);
    if (!Number.isSafeInteger(millis) || !Number.isSafeInteger(counter))
        return null;
    if (counter > MAX_COUNTER)
        return null;
    return { millis, counter };
}
/**
 * Стан, з якого підняти годинник при старті.
 *
 * Водяного знака самого по собі мало. Він зʼявився щойно, а архів
 * повний рядків із мітками, старшими за нього, — усі, написані до
 * того, як цей код узагалі існував. Годинник, піднятий із нуля або
 * з порожнього знака, узяв би настінний час; якби той відстав від
 * останньої мітки в базі (годинник пристрою перевели, або мітку
 * поставив інший пристрій, що йшов попереду), наступна власна
 * правка отримала б **меншу** мітку за вже наявну — тобто програла
 * б власній старій, назавжди й мовчки.
 *
 * Тому береться максимум із трьох: збережений знак, найбільша мітка
 * в базі й настінний час, який додасть `tickHlc` при першому виклику.
 * Читання коштує два індексовані `MAX()` один раз на запуск вкладки.
 */
export async function loadClockState(db, state) {
    const stored = parseWatermark(await state.get(SYNC_KEYS.hlcWatermark));
    const rows = await db.query(`SELECT MAX(hlc) AS hlc FROM (
       SELECT MAX(hlc) AS hlc FROM entry
       UNION ALL
       SELECT MAX(hlc) AS hlc FROM horizon_item
     )`);
    // Тільки `millis` і `counter`: `parseHlc` віддає ще й `deviceId`
    // чужого пристрою, а стану власного годинника він не належить.
    const parsed = rows[0]?.hlc ? parseHlc(rows[0].hlc) : null;
    const highest = parsed && { millis: parsed.millis, counter: parsed.counter };
    const candidates = [stored, highest].filter((s) => s !== null);
    if (candidates.length === 0)
        return { millis: 0, counter: 0 };
    return candidates.reduce((a, b) => b.millis > a.millis || (b.millis === a.millis && b.counter > a.counter) ? b : a);
}
//# sourceMappingURL=state.js.map